import React from "react";
import {Form, Input, Radio, Card} from 'antd';

import NHUeditor from '../../common/NHUeditor/index';
import NHFormItem from '../../common/NHFormItem';


const baseUrlPath = "/fwwgl/cjwt"; //学校信息管理模块路径

/**
 * 在线问答编辑表单
 * @date 2018-03-02 14:00
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            initData:this.props.initFormData,
            wt:''
        }
    }

    //获取设置富文本编辑器的方法
    setEditor=(editor)=>{
        let wtda = this.props.initFormData.wtda;
        if(wtda){
            editor.setContent(wtda);
        }
    }


    render() {

        const {getFieldDecorator,setFieldsValue} = this.props.form;
        const initFormData = this.props.initFormData;
        const {pkid, wtda, wt} = this.state.initData;
        return (
            <div>
                <Card title={'问题'}>
                    <div style={{whiteSpace: 'normal'}} dangerouslySetInnerHTML={{__html:wt}}/>
                </Card>
                <Card title={'问题答案'}>
                    <Form layout="horizontal">
                        <div style={{display:'none'}}>
                        <NHFormItem id={"pkid"} label={"主键"}
                                    form={this.props.form} initialValue={pkid}>
                                    <input />
                        </NHFormItem>
                        </div>
                        <NHFormItem id={"wtda"}
                                    form={this.props.form} initialValue={wtda}>
                                    <NHUeditor id="content"
                                        Editor={this.setEditor}
                                        getContent={this.props.getContent}
                                        width={700}
                                        height={220}
                                        autoFloatEnabled={false}
                                        toolbars={ [[
                                                'fullscreen',//全屏
                                                '|',
                                                'undo',//撤销
                                                'redo', //重做
                                                '|',
                                                'bold', //加粗
                                                'italic', //斜体
                                                'underline', //下划线
                                                'forecolor', //字体颜色
                                                'backcolor', //背景色
                                                '|',
                                                'justifyleft', //居左对齐
                                                'justifycenter', //居中对齐
                                                'justifyright', //居右对齐
                                                'justifyjustify', //两端对齐
                                                'fontfamily', //字体
                                                'fontsize', //字号
                                                
                                            ]]
                                        }
                                    />
                        </NHFormItem>
                    </Form>
                </Card>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/zxwd/EditForm.js